module.exports = __webpack_public_path__ + "img/pawn-promotion.39634525.png";